<form [formGroup]="group">
    <mat-form-field [class.is-disabled]="disabled" class="w100" [ngClass]="isInvalid(controlName, group) ? 'mat-form-field-invalid' : ''">
        <mat-label>
            {{ label | translate }}
            <span *ngIf="multiple">{{isRequired(controlName, group) ? '*' : ''}}</span>
        </mat-label>

        <ng-container *ngIf="!multiple; else multipleInput">
            <input *ngIf="!search; else searchInput" matInput #selectInput="matInput" [formControlName]="controlName"
                [matAutocomplete]="auto" smtSelect [control]="group.controls[controlName]" [selectInput]="selectInput"
                [selectAutocomplete]="autocompleteTrigger">
            <ng-template #searchInput>
                <input matInput #selectInput="matInput" [formControlName]="controlName" [matAutocomplete]="auto"
                    smtSelect [control]="group.controls[controlName]" [selectInput]="selectInput"
                    [selectAutocomplete]="autocompleteTrigger">
            </ng-template>
        </ng-container>
        <ng-template #multipleInput>
            <div *ngIf="!useChips">
                <mat-chip-list class="w100" #chipList [disabled]="disabled">
                    <mat-chip *ngFor="let option of selectedOptions" color="primary" (removed)="remove(option)">
                        {{option.value}}
                        <button *ngIf="!disabled" matChipRemove>
                            <mat-icon>cancel</mat-icon>
                        </button>
                    </mat-chip>
                    <input matInput #selectInput="matInput" [formControlName]="controlName" [matAutocomplete]="auto"
                        [matChipInputFor]="chipList" smtSelect [control]="group.controls[controlName]"
                        [selectInput]="selectInput" [selectedOptions]="selectedOptions"
                        [selectAutocomplete]="autocompleteTrigger">
                </mat-chip-list>
            </div>
            <div *ngIf="useChips">
                <h4 *ngIf="selectedOptions && selectedOptions.length > 0" class="chip">{{'ALDEN.FILTERS.CONTAINS' | translate}}</h4>
                <mat-chip-list class="w100" #chipList>
                    <mat-chip class="selected-chip" *ngFor="let option of selectedOptions" color="primary" selected
                        (removed)="remove(option)">
                        {{option.value}}
                        <button *ngIf="!disabled" matChipRemove>
                            <mat-icon class="selected-icon">cancel</mat-icon>
                        </button>
                    </mat-chip>
                </mat-chip-list>


                <h4 *ngIf="excludedOptions && excludedOptions.length > 0" class="chip">{{'ALDEN.FILTERS.NOT_CONTAINS' | translate}}</h4>
                <mat-chip-list class="w100" #excludeList [disabled]="disabled">
                    <mat-chip *ngFor="let option of excludedOptions" (removed)="remove(option)">
                        {{option.value}}
                        <button *ngIf="!disabled" matChipRemove>
                            <mat-icon>cancel</mat-icon>
                        </button>
                    </mat-chip>
                </mat-chip-list>

                <input *ngIf="!disabled" class="chip" matInput #selectInput="matInput" [formControlName]="controlName" [matAutocomplete]="auto"
                    [matChipInputFor]="chipList" smtSelect [control]="group.controls[controlName]"
                    [selectInput]="selectInput" [selectedOptions]="selectedOptions"
                    [selectAutocomplete]="autocompleteTrigger">
            </div>
        </ng-template>

        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="selectedOption($event)" class="search-select-autocomplete">
            <div class="select-warn-msg" *ngIf="maxItems && showMaxItemsMsg">
                <span>{{'ALDEN.SELECT.MESSAGES.WARNING' | translate:{count:maxItems} }}</span>
            </div>
            <mat-option *ngFor="let option of filteredOptions | async" [value]="option"
                [title]="showTooltip ? option.value : ''"
                [ngStyle]="(multiple ? isSelectedMult(option) : isSelected(option)) ? { 'background-color': '#f0f8ff'} : {}"
                [class]="optionCSS">
                <div class="option-row">
                    <span class="option-label" [style.gridColumn]="useChips ? 'span 4' : 'span 5'">
                        {{ option.value }}
                    </span>
                    <span *ngIf="multiple && useChips" class="option-suffix">
                        <mat-icon tabindex="0" (click)="exclude(option); $event.stopPropagation()"
                            (keydown.enter)="exclude(option); $event.stopPropagation()"
                            (keydown.space)="exclude(option); $event.stopPropagation()">
                            remove
                        </mat-icon>
                        <mat-icon>add</mat-icon>
                    </span>
                </div>
            </mat-option>
        </mat-autocomplete>

        <span
            *ngIf="group.controls[controlName].invalid || (!group.controls[controlName].value && (!selectedOptions || selectedOptions.length === 0))"
            matSuffix class="input-suffix">
            <mat-icon *ngIf="!searching">{{ search ? 'search' : 'arrow_drop_down' }}</mat-icon>
            <div *ngIf="searching" matSuffix class="input-suffix"><mat-spinner></mat-spinner></div>
        </span>
        <button
            *ngIf="canClean && group.controls[controlName].valid && (group.controls[controlName].value || selectedOptions?.length > 0)"
            mat-icon-button matSuffix (click)="cleanValue()" class="input-suffix">
            <mat-icon>close</mat-icon>
        </button>

        <mat-error *ngIf="!searching && searchErrorMessage">
            <span>{{ searchErrorMessage | translate }}</span>
        </mat-error>
        <mat-error *ngIf="!searching && !searchErrorMessage && group.controls[controlName]?.errors as errors">
            <ng-container *ngFor="let error of errors | keyvalue">
                <span [ngSwitch]="error.key">
                        <ng-container *ngSwitchCase="'required'">
                            {{ 'ALDEN.VALIDATORS.ERRORS.REQUIRED' | translate }}
                        </ng-container>
                        <ng-container *ngSwitchCase="'notString'">
                            {{ 'ALDEN.VALIDATORS.ERRORS.SELECTION' | translate }}
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            {{ error.value | translate }}
                        </ng-container>
                    </span>
            </ng-container>
        </mat-error>
    </mat-form-field>
</form>